// extracted by mini-css-extract-plugin
export default {"label_spec":"pictureIcon_label_spec__fA7bh","picture_icon_block":"pictureIcon_picture_icon_block__9pgtl"};